// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.interactions.HpApiInteractionsV3Handler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type {
  HpApiResponseDto,
  HpUserInteractionRequestDto,
  HpUserInteractionsOrderBy,
  HpUserInteractionsResponseDto,
} from '../..';

interface ListParams {
  activeOnly?: boolean;
  interactions?: string;
  orderBy?: HpUserInteractionsOrderBy;
  page?: number;
  pageSize?: number;
}

export const HpApiInteractionsV3Handler_add_Path = '/api/web/v3/user/interactions/add';

/**
 * Add a user interaction (favorite/hide/etc.) for a listing
 */
export const HpApiInteractionsV3Handler_add = (postData: HpUserInteractionRequestDto, client = getClient()) => {
  return httpApiRequest<never, HpUserInteractionRequestDto, HpApiResponseDto<boolean>>(
    {
      endpoint: HpApiInteractionsV3Handler_add_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};

export const HpApiInteractionsV3Handler_list_Path = '/api/web/v3/user/interactions/list';

/**
 * List the signed-in user's interactions (favorites/hidden/etc.) as listings
 */
export const HpApiInteractionsV3Handler_list = (getParams: ListParams, client = getClient()) => {
  return httpApiRequest<ListParams, never, HpApiResponseDto<HpUserInteractionsResponseDto>>(
    {
      getParams: getParams,
      endpoint: HpApiInteractionsV3Handler_list_Path,
      method: 'GET',
      contextPath: '/hotpads-api',
    },
    client,
  );
};

export const HpApiInteractionsV3Handler_remove_Path = '/api/web/v3/user/interactions/remove';

/**
 * Remove a user interaction for a listing
 */
export const HpApiInteractionsV3Handler_remove = (postData: HpUserInteractionRequestDto, client = getClient()) => {
  return httpApiRequest<never, HpUserInteractionRequestDto, HpApiResponseDto<boolean>>(
    {
      endpoint: HpApiInteractionsV3Handler_remove_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};
